import React, { useState, useEffect, useCallback, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import Card from '@material-tailwind/react/Card';
import CardHeader from '@material-tailwind/react/CardHeader';
import CardBody from '@material-tailwind/react/CardBody';
import { useLicenseList } from 'query/actions/license/Crud';
import moment from "moment";
import ButtonGroupActionLesen from './ButtonGroupActionLesen';
import differenceBy from 'lodash/differenceBy';
import { Button } from '@material-tailwind/react';
import { Chip, Tooltip } from '@mui/material';
import CustomModal from './CustomModal';
import View from './ActionButton/View';
import LicenseCard from './LicenseCard';
// recoil
import { useRecoilValue } from 'recoil';
import { userInfoAtom } from 'recoil/UserInfo';
import AddNewStaff from './AddNewStaff';
import AddNewRole from './AddNewRole';
import { useRoleList } from 'query/admin';
import ButtonGroupActionPeranan from './ButtonGroupActionPeranan';

export default function DataTableCardPeranan() {
    const userInfo = useRecoilValue(userInfoAtom);
    const { mutate, error, isError, isLoading, isSuccess } = useRoleList();
    // const { mutate, error, isError, isLoading, isSuccess, data: dataAtom } = useApplicationList();
    const [lists, setLists] = useState({});
    const [page, setPage] = useState(0);
    const [isAdmin, setIsAdmin] = useState(true);
    const countPerPage = 10;

    const [refreshTable, setRefreshTable] = useState(false);
    const [pageModal, setPageModal] = useState(null);
    const [showModal, setShowModal] = useState(false);
    async function closeModal() {
        await setShowModal(false);
    }

    const getRoleList = async (data) => {
        await mutate(data, {
            onSuccess: (data) => {
                setLists(data.data.data)
            }
        })
    }

    useEffect(() => {
        let accessToken = userInfo?.isAdmin ? '' : userInfo?.accessToken;
        let data = {'page': page, 'perPage': countPerPage, 'user': accessToken}
        getRoleList(data);
        setIsAdmin((accessToken!='' ? false : true))

        if(refreshTable){
            setRefreshTable(false)
        }
    }, [page, refreshTable]);

    // admin
    const columns = [
        {
            name: '#',
            cell: row => row.row_num,
            selector: row => row.row_num,
            sortable: true,
            width: '5rem'
        },
        {
            name: 'NAMA PERANAN',
            cell: row => <Chip className='capitalize' key={row.title} label={row.title} />,
            selector: row => row.title,
            sortable: true,
            // width: '8rem'
        },
        {
            name: 'BILANGAN PENGGUNA',
            cell: row => <div className='flex flex-col my-4'>
                    {/* <div className='mb-1'><b>{ row.email }</b></div>
                    <div className='mb-1'>{ row.name }</div> */}
                    <div>{ row.total }</div>
                </div>,
            // selector: row => row.email,
            sortable: true,
            // width: '20rem'
        },
        {
            name: ' ',
            cell: row => <ButtonGroupActionPeranan 
                        isAdmin={isAdmin} 
                        data={row} 
                        setRefreshTable={setRefreshTable}
                    />,
            // selector: row => row.license_id,
            sortable: true,
            //   width: '12%'
        }
    ];

    const rowDisabledCriteria = row => (row.disabled==='true' ? true : false);

    return (
        <>
        <Card>
            <CardHeader size='sm' color="pink" contentPosition="left">
                <h2 className="text-white text-xl">Senarai Peranan</h2>
            </CardHeader>
            <CardBody className='-mt-3'>
                <div className='flex justify-end mx-4'>
                    <Button
                        color="blue"
                        className="normal-case"
                        // buttonType="outline"
                        // size="lg"
                        // rounded={true}
                        block={false}
                        iconOnly={false}
                        ripple="dark"
                        // type="submit"
                        onClick={() => setShowModal(true)}
                    >
                        <i class="fas fa-plus pr-1"></i>Tambah Peranan
                    </Button>
                </div>
                <div className="overflow-x-auto mt-4">
                    <DataTable 
                        // title=" "
                        className='w-full'
                        columns={columns} 
                        data={lists.result}
                        progressPending={isLoading} 
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={lists.total}
                        paginationPerPage={countPerPage}
                        paginationComponentOptions={{
                          noRowsPerPage: true
                        }}
                        onChangePage={page => setPage(page - 1)}
                        // selectableRows={isAdmin}
                        // selectableRowDisabled={rowDisabledCriteria}
                        // contextActions={contextActions}
                        // onSelectedRowsChange={handleRowSelected}
                        // clearSelectedRows={toggleCleared}
                    />
                </div>
            </CardBody>
        </Card>

        {showModal ? 
            <CustomModal 
                closeModal={closeModal} 
                size={'sm'}
                title={`Tambah Peranan`}
                content={<AddNewRole closeModal={closeModal} setRefreshTable={setRefreshTable} />}
                backdropClose={true}
            /> : 
        ''}
        </>
    );
}
